import styled from "@emotion/styled";
import { lightGrey2 } from "@stepfinance/react";
import { Switch, Tooltip } from "antd";
import React, { useCallback } from "react";

import infoIcon from "../../assets/info.svg";
import { useAppConfig } from "../../contexts/app/config";
import { Slippage } from ".";

const VERSION_TX_INFO_COPY =
  "Versioned Tx is a significant upgrade that allows for more advanced routings and better prices! Make sure your connected wallet is compatible before toggling on Ver. Tx. Current compatible wallets: Phantom, Solflare, Glow and Backpack";

export const TxVersionDropdown = () => {
  const { transactionVersion, setTransactionVersion } = useAppConfig();
  const onChange = useCallback(
    (checked) => {
      setTransactionVersion(checked ? 0 : "legacy");
    },
    [setTransactionVersion],
  );
  return (
    <TxVersionSelectContainer>
      <StyledSpan>
        <span>Versioned Transaction</span>
        <Tooltip title={VERSION_TX_INFO_COPY} placement="bottom">
          <StyledInfoIcon src={infoIcon} alt="info" />
        </Tooltip>
      </StyledSpan>
      <Switch defaultChecked={transactionVersion === 0} onChange={onChange} />
    </TxVersionSelectContainer>
  );
};

export const Settings = () => {
  return (
    <SettingsContainer>
      <TxVersionDropdown />
      <Slippage />
    </SettingsContainer>
  );
};

const SettingsContainer = styled.div`
  color: ${lightGrey2};
`;

const TxVersionSelectContainer = styled.span`
  align-items: center;
  display: flex;
  margin-bottom: 0.8em;
  justify-content: space-between;
`;

const StyledSpan = styled.span`
  font-size: 0.8em;
  margin-left: 5px;
`;

const StyledInfoIcon = styled.img`
  font-size: 1em;
  height: 14px;
  margin-left: 0.25em;
  object-fit: cover;
`;
